import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';
import isPlainObject from 'lodash/isPlainObject';
import * as ReactGA from 'react-ga';
import * as requests from './requests';
import { translationMessages, DEFAULT_LOCALE } from './../i18n';
import { loadState, saveState } from './localStorage';
import { limitLength } from './formValidations';

const esc = encodeURIComponent;
const keyValToQueryString = (params) =>
  Object.keys(params)
    .filter((key) => isString(params[key]) && params[key].length > 0)
    .map((key) => `${esc(key)}=${esc(params[key])}`)
    .join('&');

//interpolate {param}s between handlebars
//https://stackoverflow.com/questions/15502629/regex-for-mustache-style-double-braces
function interpolate(str) {
  return (o) =>
    str.replace(/{([^{}]*)}/g, (a, b) => {
      const r = o[b];
      return isString(r) || isNumber(r) ? r : a;
    });
}

//Get a setting (by key) from window.APP_CONFIG or APP_CONFIG (global variable) in that order.
//If the setting does not exist, return an optional defaultValue or undefined.
function getAppConfigSetting(key, defaultValue) {
  const config = typeof window !== 'undefined' ? window.appConfig || {} : {};
  let value;
  if (key in config) {
    //config keys are allowed to have mustache template values referencing APP_CONFIG
    value = config[key];
  } else {
    value = APP_CONFIG[key];
  }
  if (isString(value)) {
    value = interpolate(value)({ ...config, ...APP_CONFIG });
  }
  return value === undefined ? defaultValue : value;
}

function orgUnitsFieldValue(obj, fieldName) {
  if (!isPlainObject(obj)) {
    throw new Error('Expected object param');
  }
  if (!isString(fieldName)) {
    throw new Error('Expected string param');
  }
  if (isArray(obj[fieldName])) {
    return obj[fieldName].join();
  }
  return obj[fieldName];
}

function trackPage(urlPathName, orgUnits, otherFields = {}) {
  if (!isString(urlPathName)) {
    throw new Error('urlPathName string param is required');
  }
  if (!orgUnits) {
    throw new Error('orgUnits param is required');
  }

  const fields = {
    urlPathName,
    ...otherFields,
  };

  if (isArray(orgUnits) && orgUnits.length > 0) {
    const orgUnit = orgUnits[0];
    fields.dimension1 = orgUnitsFieldValue(orgUnit, 'type');
    if ('value' in orgUnit) {
      fields.dimension2 = orgUnitsFieldValue(orgUnit, 'value');
    } else if ('values' in orgUnit) {
      fields.dimension2 = orgUnitsFieldValue(orgUnit, 'values');
    }
  }

  ReactGA.set(fields);
  ReactGA.pageview(urlPathName);
}

function loadIntlMessages() {
  let locale = DEFAULT_LOCALE;

  if (typeof window !== 'undefined') {
    //if available use browser preferred language
    locale = window.navigator.language.toLowerCase();
  }

  let messages;
  //if we have translations for that locale use those otherwise default locale message
  if (locale in translationMessages) {
    messages = translationMessages[locale] || {};
  } else {
    messages = translationMessages[DEFAULT_LOCALE] || {};
  }
  return { locale, messages };
}

export {
  getAppConfigSetting,
  loadIntlMessages,
  requests,
  keyValToQueryString,
  orgUnitsFieldValue,
  trackPage,
  loadState,
  saveState,
  limitLength,
};



// WEBPACK FOOTER //
// ./src/utils/index.js